import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Row } from 'components/Row';
import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { CustomCheckbox } from 'components/CustomCheckbox';
import useValidations from 'pages/Contratos/Fluxos/FluxoDescentralizados/hooks/useValidations';
import { diferenceMonths } from 'utils/DateUtils';
import moment from 'moment';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  ContratoStatus,
  URL_ADITIVO_PARAM,
  VersaoContratoEnum,
  URL_ENTE_DESCENTRALIZADO,
} from 'models/contratos';
import ModalConfirm from 'pages/Contratos/components/ModalConfirm';
import { openModal } from 'store/modules/ModalActions';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { newContratoDescentralizadoEditRoute } from 'library/Routes';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { loadContratoAdendos } from 'store/modules/AllContratos/AllContratosActions';
import { changeContratoEntePrivadoEditingValue, closeModalEntePrivadoAditivo, contratoEntePrivadoDescentralizadoCreateAditivo, contratoEntePrivadoDescentralizadoEditAditivo, loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
import { loadAllProfessorGestorByEscola } from 'store/modules/ProfessoresActions';
import { DateMaskedInput } from 'components/MaskedInputs';

interface Escola {
  id: number;
  nome: string;
  coop?: string;
  cidadeNome?: string | null;
  estadoId?: string | null;
}

const ModalAditivoEntePrivado = () => {
  const [dataInicioError, setDataInicioError] = useState('');
  const [dataFimError, setDataFimError] = useState('');
  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const escolas = useSelector((state: RootState) => state.escolas);
  const contratosEntePrivadoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePrivado
  );
  const professoresReducer = useSelector((state: any) => state.professores)
  const adendosAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoVersaoContratoUm = adendosAll.find(
    (adendo) => adendo.versaoContrato === 1
  );
  const idVersaoContrato = adendoVersaoContratoUm
    ? adendoVersaoContratoUm?.id
    : null;
  const {
    isContratoAtivoEntePrivado,
    validDadosEntePrivadoAditivo,
    validateDataInicio,
    validateDataFim,
    dataInicioIsValid,
    dataFimIsValid
  } = useValidations();
  const location = useLocation();
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const idContrato = params.id;
  const history = useHistory();
  const dispatch = useDispatch();

  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

  const handleDataChange = useCallback(
    (name, value) => {
      dispatch(changeContratoEntePrivadoEditingValue(name, value));
    },
    [dispatch]
  );

  const onDataInicioChanged = (value: string) => {
    const error = validateDataInicio(
      value,
      contratosEntePrivadoReducer.contratoEditing.dataFim,
      {
        after: languageValues.dataInicioError,
        same: languageValues.dataInicioIgualDataFimError,
      }
    );
    setDataInicioError(error);

    if (!error) {
      setDataInicioError('');
    }

    let months: unknown = diferenceMonths(
      value,
      contratosEntePrivadoReducer.contratoEditing.dataFim
    );
    if (typeof months === 'string') {
      months = parseFloat(months);
    }
    if (isNaN(months as number)) {
      months = 0;
    }
    handleDataChange('totalMeses', Math.max(months as number, 0));
  };

  const onDataFimChanged = (value: string) => {
    const error = validateDataFim(
      value,
      contratosEntePrivadoReducer.contratoEditing.dataInicio,
      {
        before: languageValues.dataFimError,
        same: languageValues.dataFimIgualDataInicioError,
      }
    );
    setDataFimError(error);

    if (!error) {
      setDataFimError('');
    }
    const dataInicioErrorValue = validateDataInicio(
      contratosEntePrivadoReducer.contratoEditing.dataInicio,
      value,
      {
        after: languageValues.dataInicioError,
        same: languageValues.dataInicioIgualDataFimError,
      }
    );
    setDataInicioError(dataInicioErrorValue);

    let months: unknown = diferenceMonths(
      contratosEntePrivadoReducer.contratoEditing.dataInicio,
      value
    );
    if (typeof months === 'string') {
      months = parseFloat(months);
    }
    if (isNaN(months as number)) {
      months = 0;
    }
    handleDataChange('totalMeses', Math.max(months as number, 0));
  };

  const dataInicioValidacaoAditivoResultado = dataInicioIsValid(
    contratosEntePrivadoReducer.contratoEditing.dataInicio,
    contratosEntePrivadoReducer.contratoEditing.dataFim,
    {
      after: languageValues.dataInicioError,
      same: languageValues.dataInicioIgualDataFimError,
    }
  );

  const dataFimValidacaoAditivoResultado = dataFimIsValid(
    contratosEntePrivadoReducer.contratoEditing.dataFim,
    contratosEntePrivadoReducer.contratoEditing.dataInicio,
    {
      before: languageValues.dataFimError,
      same: languageValues.dataFimIgualDataInicioError,
    }
  );

  const fechaModalEAtualizaContrato = () => {
    history.push(
      newContratoDescentralizadoEditRoute.getURLWithParams(
        CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
        idVersaoContrato,
        CONTRATO_PASSOS.DOCUMENTOS
      )
    );
    dispatch(closeModalEntePrivadoAditivo());
  };

  const verificaSeTemAditivo = () => {
    return adendosAll.some(
      (item) => item.versaoContrato === VersaoContratoEnum.ADITIVO
    );
  };
  const contenAditivo = verificaSeTemAditivo();

  const abrirModalCriacaoAditivo = () => {
    const fechaModal = !desabilitaCampos();
    const status = contratosEntePrivadoReducer.contratoEditing.flgStatus;

    if (fechaModal) {
      fechaModalEAtualizaContrato();
      return;
    }
    if (status === ContratoStatus.EM_EDICAO && contenAditivo === true) {
      submitAditivo();
      fechaModalEAtualizaContrato();
      return;
    }
    dispatch(
      openModal(ModalConfirm, {
        title: languageValues.criacaoAditivo,
        content: languageValues.confirmarCriacaoAditivo,
        confirmLabel: languageValues.confirmar,
        confirmCallback: () => {
          submitAditivo();
        },
        modalKey: 'modalComplete',
        maxWidth: 'sm',
      })
    );
  };

  const tituloModalAditivo = () => {
    const status = contratosEntePrivadoReducer.contratoEditing.flgStatus;
    const url = window.location.href;

    if (url.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO)) {
      switch (status) {
        case ContratoStatus.ENCERRADO:
        case ContratoStatus.NAO_INICIADO:
        case ContratoStatus.VIGENTE:
        case ContratoStatus.AGUARDANDO_EXTRATO:
          return `${languageValues.aditivo}`;
        default:
          return `${languageValues.editarAditivo}`;
      }
    }

    return languageValues.criacaoAditivo;
  };

  const desabilitaCampos = () => {
    const isCriacao = location.pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO);
    const { flgStatus, flgAtivo } = contratosEntePrivadoReducer.contratoEditing;
    if (!flgAtivo) {
      return false;
    }
    if (!isCriacao) {
      switch (flgStatus) {
        case ContratoStatus.ENCERRADO:
        case ContratoStatus.VIGENTE:
        case ContratoStatus.NAO_INICIADO:
        case ContratoStatus.AGUARDANDO_EXTRATO:
          return false;
        default:
          return true;
      }
    }
    return true;
  };

  const handleEscolaChange = (value: { value: string, label: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('nomEscola', currValue);
    handleDataChange('idEscola', currValue)
  };

  const handleRepresentanteChanged = (value: { value: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('cpfProfessor', currValue);
  }

  const getEscolas = (): Escola[] => {
    if (contratosEntePrivadoReducer.contratoEditing.nomCidade) {
      return (escolas.escolasPorCidade as unknown as Escola[]) || [];
    }
    if (idContrato) {
      return contratosEntePrivadoReducer.contratoEditing.nomEscola ? [{
        nome: contratosEntePrivadoReducer.contratoEditing.nomEscola,
        id: contratosEntePrivadoReducer.contratoEditing.idEscola
      }] : [];
    }
    return [];
  };

  const getRepresentantes = () => {
    if (contratosEntePrivadoReducer.contratoEditing.cpfProfessor) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    if (contratosEntePrivadoReducer.contratoEditing.idEscola) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    return [];
  };

  const desabilitaCampoEscola = () => {
    return true;
  }

  const desabilitaCampoRepresentantes = () => {
    return true;
  }

  const submitAditivo = async () => {
    const isEdicaoAditivo = location.pathname.includes(
      URL_ADITIVO_PARAM.EDICAO_ADITIVO
    );
    const isVersaoAditivo = location.pathname.includes(
      URL_ADITIVO_PARAM.VERSAO
    );
    const isCriacao = location.pathname.includes(
      URL_ADITIVO_PARAM.CADASTRO_ADITIVO
    );
    const aditivoData = {
      idContrato: idVersaoContrato,
      idEstado: contratosEntePrivadoReducer.contratoEditing.idEstado,
      nomCidade: contratosEntePrivadoReducer.contratoEditing.nomCidade,
      dataInicio: moment(contratosEntePrivadoReducer.contratoEditing.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
      dataFim: moment(contratosEntePrivadoReducer.contratoEditing.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
      flgAnaliseJuridica: contratosEntePrivadoReducer.contratoEditing.flgAnaliseJuridica,
      totalMeses: contratosEntePrivadoReducer.contratoEditing.totalMeses,
      versaoContrato: VersaoContratoEnum.ADITIVO
    };
    const data = { ...aditivoData };
    try {
      if (isVersaoAditivo && isEdicaoAditivo) {
        data.idContrato = idVersaoContrato;
        dispatch(
          contratoEntePrivadoDescentralizadoEditAditivo(
            Number(params.idAditivo),
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoAditivoAtualizar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      } else if (isCriacao && (contenAditivo || !contenAditivo)) {
        data.idContrato = idVersaoContrato;
        dispatch(
          contratoEntePrivadoDescentralizadoCreateAditivo(
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoAditivoSalvar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
              dispatch(loadContratoAdendos(idVersaoContrato));
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      }
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error,
        options: {
          variant: 'error',
        },
      });
    }
  };

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.MODAL_CRIACAO_ADITIVO))) {
      dispatch(loadContratoEntePrivado(Number(params.id), VersaoContratoEnum.CONTRATO));
    }
    // eslint-disable-next-line 
  }, [dispatch,
    location.pathname])

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_ADITIVO_PARAM.MODAL_EDICAO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO))) {
      dispatch(loadContratoEntePrivado(Number(params.idAditivo), VersaoContratoEnum.ADITIVO));
    }
    // eslint-disable-next-line
  }, [
    dispatch,
    location.pathname]);

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_ADITIVO_PARAM.MODAL_EDICAO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.MODAL_CRIACAO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO)
      )) {
      const idEscola = contratosEntePrivadoReducer.contratoEditing.idEscola
      if ((location.pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO) ||
        location.pathname.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO)) &&
        idEscola) {
        dispatch(loadAllProfessorGestorByEscola(idEscola));
      }
    }
    // eslint-disable-next-line 
  }, [contratosEntePrivadoReducer.contratoEditing.idEstado, dispatch, location.pathname])

  return (
    <>
      <Dialog
        open={contratosEntePrivadoReducer.isModalAditivoOpen}
        aria-labelledby='form-dialog-aditivo'
        className='form-dialog-aditivo'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 350,
        }}
        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
      >
        <DialogTitle className='form-dialog-aditivo__title-modal'>
          <div className='form-dialog-aditivo__titleContainer'>
            <Typography className='form-dialog-aditivo__titleModal'>
              {tituloModalAditivo()}
            </Typography>
            <IconButton
              aria-label='close'
              className='form-dialog-aditivo__closeButton'
              onClick={() => fechaModalEAtualizaContrato()}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='form-dialog-aditivo__titleLine'></div>
        </DialogTitle>
        <DialogContent>
          <Box className='form-dialog-aditivo__box'>
            <Card className='form-dialog-aditivo__card'>
              <Box>
                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePrivado'
                      className='form-dialog-aditivo__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosEntePrivado}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id="nomEscola"
                      label={languageValues.escola}
                      options={getEscolas().map((item: Escola) => ({
                        label: item.nome,
                        value: item.id,
                      }))}
                      value={contratosEntePrivadoReducer.contratoEditing.idEscola}
                      onChange={handleEscolaChange}
                      disabled={desabilitaCampoEscola() || !isContratoAtivoEntePrivado()}
                    />
                  </Col>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id={'representanteGestor'}
                      label={languageValues.representantesLabel}
                      options={getRepresentantes().map((item: { nome: string, cpf: string }) => ({
                        label: item.nome,
                        value: item.cpf,
                      }))}
                      value={contratosEntePrivadoReducer.contratoEditing.cpfProfessor}
                      onChange={handleRepresentanteChanged}
                      disabled={desabilitaCampoRepresentantes() || !isContratoAtivoEntePrivado()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePrivado'
                      className='form-dialog-aditivo__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosAditivo}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={'data-inicio'}
                      label={languageValues.cadastroContratoDataInicioAditivo}
                      name='dataInicio'
                      value={contratosEntePrivadoReducer.contratoEditing.dataInicio}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const value = event.target.value.trim();
                        handleDataChange('dataInicio', value);
                        if (value.length === 10) {
                          onDataInicioChanged(value);
                        } else {
                          setDataInicioError('');
                        }
                      }}
                      InputProps={{
                        inputComponent: DateMaskedInput,
                      }}
                      helperText={
                        dataInicioError ||
                        (!dataInicioValidacaoAditivoResultado.status ? dataInicioValidacaoAditivoResultado.error : '')
                      }
                      error={!dataInicioValidacaoAditivoResultado.status || !!dataInicioError}
                      disabled={!desabilitaCampos()}
                    />
                  </Col>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={'data-fim'}
                      label={languageValues.cadastroContratoDataFimAditivo}
                      name='dataFim'
                      value={contratosEntePrivadoReducer.contratoEditing.dataFim}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const value = event.target.value.trim();
                        handleDataChange('dataFim', value);
                        if (value.length === 10) {
                          onDataFimChanged(value);
                        } else {
                          setDataFimError('');
                        }
                      }}
                      InputProps={{
                        inputComponent: DateMaskedInput,
                      }}
                      helperText={
                        dataFimError ||
                        (!dataFimValidacaoAditivoResultado.status ? dataFimValidacaoAditivoResultado.error : '')
                      }
                      error={!dataFimValidacaoAditivoResultado.status || !!dataFimError}
                      disabled={!desabilitaCampos()}
                    />
                  </Col>
                </Row>

                <Row className='form-dialog-aditivo__row-content'>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <div className='form-dialog-aditivo__label-total-meses'>
                      {languageValues.totalMesesContratados}
                    </div>
                    <div className='form-dialog-aditivo__value-total-meses'>
                      {isNaN(
                        Number(contratosEntePrivadoReducer.contratoEditing.totalMeses)
                      )
                        ? 0
                        : Number(
                          contratosEntePrivadoReducer.contratoEditing.totalMeses
                        ).toString()}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomCheckbox
                      id={'analise-juridica'}
                      className={'form-dialog-aditivo__analise-juridica'}
                      label={languageValues.flgAnaliseJuridicaAceite}
                      name='flgAnaliseJuridica'
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        handleDataChange(
                          'flgAnaliseJuridica',
                          event.target.checked
                        );
                      }}
                      checked={
                        contratosEntePrivadoReducer.contratoEditing
                          .flgAnaliseJuridica
                      }
                      disabled={!desabilitaCampos()}
                    />
                  </Col>
                </Row>
              </Box>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions className='form-dialog-aditivo__dialog-actions'>
          <Button
            className='form-dialog-aditivo__btnClose'
            onClick={() => fechaModalEAtualizaContrato()}
          >
            {languageValues.cancelButton}
          </Button>
          <Button
            className='form-dialog-aditivo__btnSave'
            onClick={() => abrirModalCriacaoAditivo()}
            disabled={!validDadosEntePrivadoAditivo()}
          >
            {languageValues.concluir}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ModalAditivoEntePrivado);

